import { createActionType } from '../core';
import { NAME } from './constants';

export const AUTHORIZE_BY_APPLICATION = createActionType(`${NAME}/AUTHORIZE_BY_APPLICATION`);

export const GET_TOKEN = createActionType(`${NAME}/GET_TOKEN`);